<div class="w-full pt-10 sm:pt-12 md:pt-16">
  <div *ngIf="this.paymentState.status == 0; else showStatus">
    <div class="flex flex-col items-center gap-9">
      <img
        class="md:w-[120px] mt-16 sm:w-[100px] mx-auto w-[100px]"
        src="assets/images/ui/loader.gif"
        alt=""
      />
      <div class="text-center mt-12">
        <h3
          class="sm:text-2xl text-2xl md:text-3xl text-blue-theme-color font-semibold mb-3"
        >
          Your payment confirmation process is ongoing.
        </h3>
        <p
          class="sm:text-[16px] text-[16px] md:text-[18px] font-semibold text-[#000000DE]"
        >
          Please wait until it is completed. This will take a maximum of 30 to
          40 seconds.
        </p>
      </div>
    </div>
  </div>
  <ng-template #showStatus>
    <div class="flex flex-col items-center gap-9">
      <img
        class="md:w-[238px] sm:w-[200px] w-[200px]"
        [src]="
          this.paymentState.status == 1
            ? 'assets/images/ui/paymentuccessful.png'
            : 'assets/images/ui/failed.png'
        "
        alt=""
      />
      <div class="text-center">
        <h3
          class="sm:text-2xl text-2xl md:text-3xl text-blue-theme-color font-semibold mb-3"
        >
          {{
            this.paymentState.status == 1
              ? "Payment Successful!"
              : "Oops, Your payments has failed!"
          }}
        </h3>
        <p
          class="sm:text-[16px] text-[16px] md:text-[18px] font-semibold text-[#000000DE]"
        >
          {{
            this.paymentState.status == 1
              ? "The payment has been done successfully. Thanks for being there with us."
              : "Due to some technical issue your payment has failed."
          }}
        </p>
      </div>

      <!-- <button
        color="primary"
        (click)="onUpdatePaymentInApi()"
        mat-flat-button
        class="!bg-blue-theme-color w-auto !px-16 !h-14 text-white-color"
      >
        {{ this.paymentState.status == 1 ? "OKAY" : "Back to Order" }}
      </button> -->

      <div class="action-buttons">
        <button
          class="btn bg-blue-dark text-white-color"
          (click)="downloadWaybill()"
        >
          Download Waybill
        </button>
        <button
          class="btn bg-blue-theme-color text-white-color"
          (click)="viewOrderDetail()"
        >
          Order Detail
        </button>
      </div>
    </div>
  </ng-template>
</div>
